/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Feature_AgentsInputs */



/**
* | output |
* | --- |
* | "oneAI Relays" |
*
* @param {Plan_Gate_Feature_AgentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_feature_agents = /** @type {((inputs?: Plan_Gate_Feature_AgentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Feature_AgentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI-Relays")
	return /** @type {LocalizedString} */ ("oneAI Relays")
});